import anime from 'animejs';
import React, { useEffect, useState } from 'react';

import { useIntersect } from '../../../hooks/useIntersect';
import { elastic as easing } from '../../../utils/easings';

import Animation from './Animation';
import styles from './SliderFlex.module.css';
import Toggler from './Toggler';

const SliderFlex = ({ toggles, images }) => {
  const { observerEntry, elementRef } = useIntersect();

  const [previousPosition, setPreviousPosition] = useState(null);
  const [currentPosition, setCurrentPosition] = useState(0);

  const [timelines, setTimelines] = useState();

  useEffect(() => {
    if (images) {
      const newTimelines = [];
      images.forEach(() =>
        newTimelines.push({
          enter: anime.timeline({
            autoplay: false,
            easing,
          }),
          isReady: false,
          isPlayed: false,
        }),
      );
      setTimelines(newTimelines);
    }
  }, [images]);

  useEffect(() => {
    if (
      observerEntry.isIntersecting &&
      timelines?.[currentPosition]?.isReady &&
      timelines?.[currentPosition]?.isPlayed === false &&
      previousPosition === null
    ) {
      timelines[currentPosition].enter.play();
      setTimeout(() => {
        const newTimelines = timelines.map((t, i) => {
          if (i === currentPosition) return { ...t, isPlayed: true };
          return t;
        });
        setTimelines(newTimelines);
      }, 500);
    }
  }, [
    observerEntry.isIntersecting,
    timelines,
    currentPosition,
    previousPosition,
  ]);

  useEffect(() => {
    if (
      timelines?.[previousPosition]?.isReady &&
      timelines?.[currentPosition]?.isReady &&
      timelines?.[currentPosition]?.isPlayed === false
    ) {
      timelines[previousPosition].enter.restart();
      timelines[previousPosition].enter.pause();
      if (
        timelines[currentPosition].isReady &&
        !timelines[currentPosition].isPlayed
      ) {
        setTimeout(() => timelines[currentPosition].enter.play(), 100);
      }
      const newTimelines = timelines.map((t, i) => {
        if (i === previousPosition) return { ...t, isPlayed: false };
        if (i === currentPosition) return { ...t, isPlayed: true };
        return t;
      });
      setTimelines(newTimelines);
    }
  }, [previousPosition, currentPosition, timelines]);

  return (
    <div className={styles.container}>
      <div className={styles.words}>
        <Toggler
          toggles={toggles}
          currentPosition={currentPosition}
          setCurrentPosition={setCurrentPosition}
          setPreviousPosition={setPreviousPosition}
        />
        <div
          ref={elementRef}
          style={{ position: 'absolute', bottom: '250px' }}
        />
      </div>
      <div className={styles.animationsContainer}>
        <Animation
          imagesArr={images}
          timelines={timelines}
          setTimelines={setTimelines}
        />
      </div>
    </div>
  );
};
export default SliderFlex;
